import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import projectPegawaiService from "../../services/projectPegawaiService";
import Cookies from "js-cookie";
import presensiProyekService from "../../services/presensiProyekService";

export const initialState = {
    loading_project_pegawai: false,
    data_project_pegawai: [],
    data_import:[],
    showMessage:false,
    message:'',
}


export const getDataProjectPegawai = createAsyncThunk('project_pegawai/data',async (data, { rejectWithValue }) => {
    try {
        const response = await projectPegawaiService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('presensi_proyek/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await projectPegawaiService.data_import(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('presensi_proyek/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await projectPegawaiService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('presensi_proyek/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await projectPegawaiService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})



export const projectPegawaiSlice = createSlice({
    name: 'project_pegawai',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_project_pegawai = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataProjectPegawai.fulfilled, (state, action) => {
                state.loading_project_pegawai = false
                state.data_project_pegawai = action.payload??[]
            })
            .addCase(getDataProjectPegawai.pending, (state) => {
                state.loading_project_pegawai = true
            })
            .addCase(getDataProjectPegawai.rejected, (state, action) => {
                state.loading_project_pegawai = false
                state.data_project_pegawai = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_project_pegawai = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_project_pegawai = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_project_pegawai = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = projectPegawaiSlice.actions

export default projectPegawaiSlice.reducer
